import { useCallback, useState } from "react";
import {
  Alert,
  Button,
  Form,
  Input,
  Layout,
  Modal,
} from "antd";
import { ArrowLeftOutlined, SafetyOutlined, SearchOutlined } from "@ant-design/icons";
import NetworkApi from "../../network/networkApi";
import { useHistory } from "react-router-dom";
import "./login.css";

const emailMissingMessage =
  "Таны бүртгэлд Имэйл хаяг бүртгэгдээгүй байна. Та харьяаллын сумын агронамитай холбогдож мэдээллээ шинэчлүүлнэ үү.";
const emailMismatchMessage =
  "Имэйл хаягийн мэдээлэл зөрж байна. Та шалгаад дахин оруулна уу.";

const ForgotPassword = () => {
  const history = useHistory();
  const [form] = Form.useForm();
  const [lookupLoading, setLookupLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [registeredEmail, setRegisteredEmail] = useState<string>();
  const [errorMessage, setErrorMessage] = useState<string>();

  const checkRegisteredEmail = useCallback(async () => {
    try {
      const rd = await form.validateFields(["rd"]);
      setLookupLoading(true);
      setErrorMessage(undefined);
      setRegisteredEmail(undefined);
      form.resetFields(["email"]);

      const result = await NetworkApi.requestPost("/api/auth/password/email", rd);
      if (result.resultCode === 200 && result.result?.email) {
        setRegisteredEmail(result.result.email);
      } else {
        setErrorMessage(result.message || emailMissingMessage);
      }
    } catch (error: any) {
      if (error?.errorFields) return;
      setErrorMessage(emailMissingMessage);
    } finally {
      setLookupLoading(false);
    }
  }, [form]);

  const forgotPassword = useCallback(async (values: any) => {
    setSubmitLoading(true);
    setErrorMessage(undefined);
    const result = await NetworkApi.requestPost("/api/auth/password/reset", values);
    setSubmitLoading(false);

    if (result.resultCode === 200 && result.result?.success !== false) {
      Modal.success({
        title: "Амжилттай!",
        content:
          "Таны бүртгэлтэй и-мэйл хаяг руу шинэ нууц үг илгээгдсэн. Inbox, spam, junk хэсгээ шалгана уу.",
        okText: "Хаах",
        onOk: () => history.push("/"),
      });
      return;
    }

    setErrorMessage(result.message || emailMismatchMessage);
  }, [history]);

  return (
    <Layout className="login-layout">
      <header className="login-header">
        <div className="login-header-left">
          <img src="/logosingle.png" alt="ХХААХҮЯ" className="login-header-logo" />
          <div className="login-header-divider" />
          <div>
            <h1 className="login-header-title">Тариалан үйлдвэрлэлийн нэгдсэн систем</h1>
            <div className="login-header-subtitle">
              Хүнс, хөдөө аж ахуй, хөнгөн үйлдвэрийн яам
            </div>
          </div>
        </div>
      </header>
      <div className="login-gold-bar" />

      <div className="forgot-center">
        <div className="forgot-card login-form-card">
          <div className="login-form-header">
            <div className="login-form-emblem"><SafetyOutlined /></div>
            <h2 className="login-form-title">Нууц үг сэргээх</h2>
            <p className="login-form-desc">
              Регистрийн дугаараар бүртгэлтэй имэйлээ шалгана уу.
            </p>
          </div>

          <Form form={form} name="password_form" onFinish={forgotPassword} layout="vertical">
            <Form.Item
              name="rd"
              label="Регистрийн дугаар"
              rules={[{ required: true, message: "Регистрийн дугаар оруулна уу!" }]}
            >
              <Input
                size="large"
                placeholder="Регистрийн дугаар"
                onChange={() => {
                  setRegisteredEmail(undefined);
                  setErrorMessage(undefined);
                  form.resetFields(["email"]);
                }}
                addonAfter={
                  <Button
                    type="link"
                    icon={<SearchOutlined />}
                    loading={lookupLoading}
                    onClick={checkRegisteredEmail}
                  >
                    Шалгах
                  </Button>
                }
              />
            </Form.Item>

            {registeredEmail && (
              <Alert
                type="info"
                showIcon
                message="Таны бүртгэлтэй имэйл хаяг:"
                description={registeredEmail}
                className="forgot-email-alert"
              />
            )}

            {errorMessage && (
              <Alert
                type="error"
                showIcon
                message={errorMessage}
                className="forgot-email-alert"
              />
            )}

            {registeredEmail && (
              <Form.Item
                name="email"
                label="Имэйл хаяг"
                rules={[{ required: true, type: "email", message: "Имэйл хаяг оруулна уу!" }]}
              >
                <Input size="large" type="email" placeholder="Имэйл хаяг" />
              </Form.Item>
            )}

            {registeredEmail && (
              <Form.Item>
                <Button loading={submitLoading} type="primary" htmlType="submit" block>
                  Илгээх
                </Button>
              </Form.Item>
            )}

            <div className="login-form-links forgot-back-link">
              <Button type="link" icon={<ArrowLeftOutlined />} onClick={() => history.push("/")}>
                Нэвтрэх хуудас руу буцах
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPassword;
